import style from "./UpgradeToPremium.module.css";
import Icon from "@/ui/icon/Icon";
import Button from "@/ui/button/Button";
import { usePriceInfo } from "@/features/payments/hooks/usePriceInfo";
function UpgradeToPremium() {
	const { priceInfo, isPending } = usePriceInfo();

	const plan = {
		name: "Postani premium!",
		price: priceInfo?.price_yearly,
		benefits: [
			{
				name: "Neograničen pristup sadržaju",
				check: true,
			},
			{
				name: "Provjera znanja",
				check: true,
			},
		],
	};

	if (isPending) return <></>;

	return (
		<div className={`${style.offer} ${style.preferred}`} key={plan.name}>
			<div className={style.offerHeader}>
				<h3>{plan.name}</h3>
			</div>
			<div className={style.offerBody}>
				<ul>
					{plan.benefits.map((benefit, index) => (
						<li key={index}>
							<Icon
								icon={benefit.check ? "fa-check" : "fa-times"}
							/>
							<span>{benefit.name}</span>
						</li>
					))}
				</ul>
			</div>
			<div className={style.offerFooter}>
				<div className={style.info}>
					<div className={style.price}>
						<div className={style.amount}>
							{plan?.price.toLocaleString("en-US", {
								minimumFractionDigits: 0,
								maximumFractionDigits: 2,
							})}
						</div>
						<div className={style.currency}>KM</div>
					</div>
					<div className={style.sepp}>
						<Icon icon="fa-slash-forward" />
					</div>
					<div className={style.period}>godišnje</div>
				</div>
				<Button
					to="plans"
					onClick={plan.onSelect}
					className={style.btn}
				>
					Saznaj više
				</Button>
			</div>
		</div>
	);
}

export default UpgradeToPremium;
